const DEVICE_TYPE_MAP = {
  badge: 1,
  listing: 2
}

const DEVICE_NAME_MAP = {
  badge: '智能胸牌',
  listing: '智能挂牌'
}

export const getDeviceType = (activeTab) => DEVICE_TYPE_MAP[activeTab]

export const getDeviceName = (activeTab) => DEVICE_NAME_MAP[activeTab]
